import { useQueryParam } from "./useQuery";

export function useTaskDrawerIsOpen() {
  const [taskId] = useQueryParam("task");
  return !!taskId;
}
